import React from 'react';

const About = () => {
    return (
        <div>
            <h2 className='text-3xl' >About page</h2>
        </div>
    );
};

export default About;